import { useCallback } from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate } from "react-router";
import {
  ShopForVehicleBanner,
  selectClearShopForVehicle,
  selectShopForVehicle,
  useShopForVehicle,
} from "@modules/shared";
import { LAYOUT_MAX, LAYOUT_PX } from "./layoutConstants";

export const ShopForVehicleStrip = () => {
  const navigate = useNavigate();
  const selection = useShopForVehicle(selectShopForVehicle);
  const clearSelection = useShopForVehicle(selectClearShopForVehicle);

  // Garage list handles both cases: shows saved vehicles, or its own empty-state add prompt.
  const onManage = useCallback(() => {
    void navigate("/vehicles");
  }, [navigate]);

  return (
    <Box px={LAYOUT_PX} pt={3} pb={1} bg={selection === null ? "transparent" : "white"}>
      <Box maxW={LAYOUT_MAX.content} mx="auto" w="100%">
        <ShopForVehicleBanner selection={selection} onManage={onManage} onClear={clearSelection} />
      </Box>
    </Box>
  );
};
